export default __webpack_public_path__ + "191bff1b8ac401ec73e994ad1081d4f8.png";